import type { NotificationData } from '../../features/notifications/NotificationRegistry';

export function getUnreadSupportReplyNotificationIds(
  notifications: readonly NotificationData[]
): string[] {
  return notifications
    .filter((notification) => notification.type === 'support-reply' && !notification.read)
    .map((notification) => notification.id);
}

export function formatSupportUnreadCount(count: number): string {
  return count > 99 ? '99+' : String(count);
}
